module.exports = __webpack_public_path__ + "img/1574219313.bc0bb259.jpg";